module.exports = __webpack_public_path__ + "img/partners3.4b916d97.png";